module.exports = __webpack_public_path__ + "static/img/cassiano.b84d2f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_supporters/cassiano.jpg
// module id = RJcO
// module chunks = 1